import { logOut } from 'actions/user';
import store from '../store';

export function handleUnauthorized(f: (...args: any[]) => Promise<any>) {
  async function wrapper(...args: any[]) {
    try {
      return await f(...args);
    } catch (err) {
      if (err.response && err.response.status === 401) {
        store.dispatch(logOut());
        throw err;
      } else {
        throw err;
      }
    }
  }

  return wrapper;
}

export default {
  handleUnauthorized,
};
